const requestFiles = {
  FILE_REQUEST_LOADING: "FILE_REQUEST_LOADING",
  FILE_REQUEST_SUCCESS: "FILE_REQUEST_SUCCESS",
  FILE_REQUEST_FAILURE: "FILE_REQUEST_FAILURE",
};

const cancelRequest = {
  CANCEL_REQUEST_LOADING: "CANCEL_REQUEST_LOADING",
  CANCEL_REQUEST_SUCCESS: "CANCEL_REQUEST_SUCCESS",
  CANCEL_REQUEST_FAILURE: "CANCEL_REQUEST_FAILURE",
};

const deleteFiles = {
  DELETE_FILES_LOADING: "DELETE_FILES_LOADING",
  DELETE_FILES_SUCCESS: "DELETE_FILES_SUCCESS",
  DELETE_FILES_FAILURE: "DELETE_FILES_FAILURE",
};

const downloadSupportFileConstants = {
  DWNLD_SUPPORT_FILE_LOADING: "DWNLD_SUPPORT_FILE_LOADING",
  DWNLD_SUPPORT_FILE_SUCCESS: "DWNLD_SUPPORT_FILE_SUCCESS",
  DWNLD_SUPPORT_FILE_FAILURE: "DWNLD_SUPPORT_FILE_FAILURE",
};

export {
  requestFiles,
  cancelRequest,
  deleteFiles,
  downloadSupportFileConstants,
};
